import { MdBuild, MdCloudQueue } from "@onemind-services-llc/react-icons-ng/md";
import { HiOutlineShieldCheck } from "@onemind-services-llc/react-icons-ng/hi";
import { RiRadarLine } from "@onemind-services-llc/react-icons-ng/ri";

export const CSPM_WORKS_CONSTANTS = {
  title: "How OneMind’s CSPM Works",
  list: [
    {
      icon: RiRadarLine,
      title: "Configuration & Risk Intelligence ",
      content:
        "Scans cloud workloads, storage, networking, IAM, and container services for security posture violations. ",
    },
    {
      icon: HiOutlineShieldCheck,
      title: "Compliance & Policy Enforcement ",
      content:
        "Monitors for drift against organizational policies and industry standards (CIS, NIST, PCI-DSS, HIPAA). ",
    },
    {
      icon: MdBuild,
      title: "Automated Remediation ",
      content:
        "Fixes misconfigurations automatically or routes them to your DevSecOps pipeline or ticketing systems like Jira or ServiceNow. ",
    },
    {
      icon: MdCloudQueue,
      title: "Multi-Cloud Visibility ",
      content:
        "Unifies findings across AWS, Azure, and Google Cloud in a single, correlated dashboard. ",
    },
  ],
};
